import { render, staticRenderFns } from "./Draggable.vue?vue&type=template&id=b42c52f0"
import script from "./Draggable.vue?vue&type=script&lang=js"
export * from "./Draggable.vue?vue&type=script&lang=js"
import style0 from "./Draggable.vue?vue&type=style&index=0&id=b42c52f0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports